import { ReactNode } from "react";
import {
  Key,
  Popover as RAPopover,
  PopoverProps as RAPopoverProps,
  Select,
  Selection,
} from "react-aria-components";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import FilterListBox from "./FilterListBox/FilterListBox";
import { popoverContainer } from "./popover.css";

interface PopoverSelectProps extends RAPopoverProps {
  popoverTrigger: ReactNode;
  children: ReactNode;
  handleOnChange: (keys: Selection) => void;
  selectedKey: Key | null | undefined;
}

const PopoverSelect = ({
  popoverTrigger,
  children,
  handleOnChange,
  selectedKey,
  ...props
}: PopoverSelectProps) => {
  const { popoverSelectLabel } = usePlosTranslations();

  return (
    <Select
      aria-label={popoverSelectLabel}
      onChange={(key) => {
        if (key != null) {
          handleOnChange(new Set([key]));
        } else {
          handleOnChange(new Set());
        }
      }}
      value={selectedKey}
    >
      {popoverTrigger}
      <RAPopover
        className={popoverContainer}
        placement="bottom start"
        {...props}
      >
        <FilterListBox>{children}</FilterListBox>
      </RAPopover>
    </Select>
  );
};

export default PopoverSelect;
